export default __webpack_public_path__ + "static/media/plain-sticker-w.441fb318.png";